import React from "react";

const BotaoSuporte = ({
  texto = "Falar com o suporte",
  mensagem = "Olá, gostaria de tirar dúvidas sobre a plataforma.",
  className = "btn btn-success",
  icon = "bx bx-chat bx-xs me-1",
}) => {
  const url = `https://api.whatsapp.com/send?phone=5511915744067&text=${encodeURIComponent(mensagem)}`;

  return (
    <React.Fragment>
      <a href={url} target="_blank" rel="noreferrer noopener" className={className}>
        <i className={icon} aria-hidden="true" />
        {texto}
      </a>
    </React.Fragment>
  );
};

export default BotaoSuporte;
